
import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import AddNewKotPrinterDialog from "../dialogs/add-new-kot-printer-dialog.vue";
import AssignItemsToPrinterDialog from "../dialogs/assign-items-to-printer-dialog.vue";
import MasterKotPrinterConfigDialog from "../dialogs/master-kot-printer-config-dialog.vue";
import ModifyPrinterDialog from "../dialogs/modify-printer-dialog.vue";
import setupPrinterDialog from "../dialogs/setup-printer-dialog.vue";
import PrintTemplateTestPrint from "../print-template/print-template-test-print.vue";
export default {
  components: {
    setupPrinterDialog,
    AddNewKotPrinterDialog,
    AssignItemsToPrinterDialog,
    ModifyPrinterDialog,
    MasterKotPrinterConfigDialog,
    PrintTemplateTestPrint
  },
  data() {
    return {
      loading: false,
      showPrinterSetupDialog: false,
      showAddNewPrinterDialog: false,
      showAssignItemsToPrinterDialog: false,
      showModifyPrinterDialog: false,
      showModifyMasterKotPrinterDialog: false,
      addedPrinters: [],
      availableUnusedPrinters: [],
      selectedPrinter: ""
    };
  },
  computed: {
    ...mapState("restaurant", ["printers", "isQzConnected"]),
    ...mapGetters("menu", ["getPrinterAssignedItems"])
  },
  watch: {
    isQzConnected() {
      this.initPrinters();
    }
  },
  mounted() {
    this.getMenuList(false);
    this.initPrinters();
  },
  methods: {
    ...mapActions("menu", ["getMenuList"]),
    initPrinters() {
      qz.printers
        .find()
        .then(
          ((printer) => {
            // this.availablePrinters = printer;
            printer?.forEach((el) => {
              if (!this.printers?.find((p) => p.name == el)) {
                this.availableUnusedPrinters.push({
                  name: el,
                  nickname: "",
                  tag: "kot",
                  selected: false
                });
              }
            });
          }).bind(this)
        )
        .catch((errr) => {
          console.error("QZ error::: ", errr);
          this.$nuxt.$emit(
            "show-error-toast",
            "QZ Printer is not responding. Please open the QZ Tray app to connect the KOT printer"
          );
          this.availableUnusedPrinters = [];
        })
        .finally(() => {});
    },
    printerAddedPostAction(printers) {
      this.addedPrinters = printers;
      this.showAddNewPrinterDialog = false;
      this.showAssignItemsToPrinterDialog = true;
    },
    assignItemsToPrinter(id) {
      // this.showModifyPrinterDialog = true;
      this.addedPrinters = [id];
      this.showAssignItemsToPrinterDialog = true;
    },
    printerSelected(id) {
      // return;
      this.selectedPrinter = id;
      this.showModifyPrinterDialog = true;
    },
    testPrintV2(p) {
      const data = [
        {
          type: "pixel",
          format: "html",
          flavor: "plain" // file
        }
      ];

      this.getComponentInstance()
        .then((htmlContent) => {
          data[0].data = htmlContent;
          // data.push(
          //   "\x1B" + "\x69" // cut paper
          // );
          // data.push(
          //   "\x0A",
          //   "\x0A",
          //   "\x1B" + "\x61" + "\x31", //center align
          //   "Powered by foaps.co",
          //   "\x1B" + "\x61" + "\x30" //left align
          // );
          p = p.name || p;
          qz.printers
            .find(p)
            .then((printer) => {
              let config = qz.configs.create(printer);
              return qz.print(config, data);
            })
            .then(
              (() => {
                this.$toasted.show("Print request sent to the printer " + p);
              }).bind(this)
            );
        })
        .then(() => {})
        .catch((e) => {
          console.log(e);
        });
    },
    testPrint(p) {
      var data = [
        "\x1B" + "\x40", // init
        "\x1B" + "\x61" + "\x31", // center align
        "\x1B" + "\x2D" + "\x02", //underline 2 dot thick
        "                                          " + "\x0A",

        "Test Print from foaps.co",
        "\x1B" + "\x2D" + "\x00", //cancel underline
        //'#' + '\x0A',

        "\x0A",
        "\x1B" + "\x61" + "\x30", // left align
        "Printer Name: " + "\x0A" + p + "\x0A",
        "\x0A",
        "\x0A" + "\x0A" + "\x0A" + "\x0A" + "\x0A",
        "\x1B" + "\x69", // cut paper
        "\x10" + "\x14" + "\x01" + "\x00" + "\x05"
      ];
      p = p.name || p;
      qz.printers
        .find(p)
        .then((printer) => {
          let config = qz.configs.create(printer);
          console.log("printing...");
          return qz.print(config, data);
        })
        .then(
          (() => {
            this.$toasted.show("Print request sent to the printer " + p);
          }).bind(this)
        )
        .catch((e) => {
          console.log(e);
        });
    },
    getComponentInstance() {
      return new Promise((resolve, reject) => {
        new Vue({
          ...PrintTemplateTestPrint,
          parent: this,
          mounted: function () {
            this.$nextTick(() => {
              resolve(this.$el.innerHTML);
            });
          }
        }).$mount();
      });
    }
  }
};
